{
  "search": "Szukaj",
  "search_no_results_1": "O nie!",
  "search_no_results_2": "Nie znaleziono emoji",
  "pick": "Wybierz emoji",
  "add_custom": "Dodaj niestandardowe emoji",
  "categories": {
    "activity": "Aktywność",
    "custom": "Niestandardowe",
    "flags": "Flagi",
    "foods": "Żywność i napoje",
    "frequent": "Często używane",
    "nature": "Zwierzęta i natura",
    "objects": "Obiekty",
    "people": "Buźki i Osoby",
    "places": "Podróże i miejsca",
    "search": "Wyniki wyszukiwania",
    "symbols": "Symbole"
  },
  "skins": {
    "choose": "Wybierz domyślny odcień skóry",
    "1": "Domyślny",
    "2": "Jasny",
    "3": "Średnio-jasny",
    "4": "Średni",
    "5": "Średnio-ciemny",
    "6": "Ciemny"
  }
}
